export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const PHONE = 'phone';
export const D_O_B = 'dateOfBirth';
export const SSN = 'ssn';
export const TITLE_ID = 'titleId';
export const SPECIALTY_ID = 'specialtyId';
export const MEDICAL_GROUP_ID = 'medicalGroupId';



// WEBPACK FOOTER //
// ./src/constants/ProfileFields.js